import { formatNumber } from "@src/lib/formatNumber"
import { useAddRecentTransaction } from "@rainbow-me/rainbowkit"
import { Dispatch, SetStateAction, useState } from "react"
import { useAccount, useContractWrite, usePrepareContractWrite } from "wagmi"
import { useConnectWithWalletKit } from "react-walletkit"
import { zeroAddress } from "viem"
import SlicerContract from "@src/lib/artifacts/contracts/Slicer.sol/Slicer"
import executeTransaction from "@src/lib/executeTransaction"

export const OWNERS_VIEW = (params: any) => {
  const {
    slicerId,
    slicerAddress,
    totalSlices,
    owners,
    unreleased,
    setUnreleased
  } = params

  return (
    <>
      <div className="sl-pb-6 sl-text-center">
        <h1 className="sl-fonts">Slicer owners</h1>
        <p className="sl-pt-4">{formatNumber(totalSlices)} Total slices</p>
      </div>
      <ul className="sl-max-w-sm sl-pt-6 sl-mx-auto">
        {owners.map((el, key) => (
          <li key={key}>
            <OwnerBlock
              index={Number(key)}
              slicerAddress={slicerAddress}
              slicerId={slicerId}
              totalSlices={totalSlices}
              owner={owners[Number(key)]}
              unreleasedOwner={unreleased[Number(key)].result}
              unreleased={unreleased}
              setUnreleased={setUnreleased}
            />
            {key != owners.length - 1 && (
              <hr className="sl-my-8 sl-border-gray-300" />
            )}
          </li>
        ))}
      </ul>
    </>
  )
}

export type AddressAmount = {
  address: `0x${string}`
  amount: number
}

type Props = {
  index: number
  slicerAddress: string
  slicerId: number
  totalSlices: number
  owner: AddressAmount
  unreleasedOwner: bigint
  unreleased: number[]
  setUnreleased: Dispatch<SetStateAction<number[]>>
}

const OwnerBlock = ({
  index,
  slicerAddress,
  slicerId,
  totalSlices,
  owner,
  unreleasedOwner,
  unreleased,
  setUnreleased
}: Props) => {
  const { address: account } = useAccount()
  const addRecentTransaction = useAddRecentTransaction()
  const { connect: connectWalletKit } = useConnectWithWalletKit()

  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)

  const unreleasedAmount =
    unreleasedOwner && unreleasedOwner != BigInt(0)
      ? Number(unreleasedOwner / BigInt(10 ** 16)) / 100
      : null

  const { config } = usePrepareContractWrite({
    address: slicerAddress,
    abi: SlicerContract.abi,
    functionName: "release",
    args: [owner.address, zeroAddress, true]
  })
  const { writeAsync } = useContractWrite(config)

  const submit = async () => {
    await executeTransaction(
      writeAsync,
      setLoading,
      `Withdraw ${unreleasedAmount} ETH | Slicer #${slicerId}`,
      addRecentTransaction,
      () => {
        setSuccess(true)
        const newUnreleased = [...unreleased]
        newUnreleased[index] = 0
        setUnreleased(newUnreleased)
      }
    )
  }

  return (
    <div className="sl-flex sl-items-center sl-justify-between">
      <p className="sl-truncate">{owner.address}</p>
      <div className="sl-text-right sl-min-w-[150px]">
        <p>
          <b className="sl-pr-1">{formatNumber(owner.amount)}</b>{" "}
          <span className="sl-text-sm">
            ({((owner.amount / totalSlices) * 100).toFixed(1)}%)
          </span>
        </p>

        {!success ? (
          unreleasedAmount ? (
            <p className="sl-text-sm sl-font-medium sl-text-gray-400">
              {!loading ? (
                <a onClick={account ? submit : connectWalletKit}>
                  Release{" "}
                  {unreleasedAmount == 0 && unreleasedOwner != BigInt(0)
                    ? "~0"
                    : unreleasedAmount}{" "}
                  Ξ
                </a>
              ) : (
                "Releasing ..."
              )}
            </p>
          ) : null
        ) : (
          <p className="sl-text-sm sl-font-medium sl-text-gray-400">
            Released {unreleasedAmount} Ξ! 🎉
          </p>
        )}
      </div>
    </div>
  )
}

export default OWNERS_VIEW
